/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: '비즈니스 전화',
  [phoneTypes.extension]: '내선 번호',
  [phoneTypes.home]: '집 전화번호',
  [phoneTypes.mobile]: '휴대폰',
  [phoneTypes.phone]: '전화',
  [phoneTypes.unknown]: '알 수 없는 전화 유형',
  [phoneTypes.company]: '회사 번호',
  [phoneTypes.direct]: '직통 번호',
  [phoneTypes.contact]: '연락처 전화번호',
  [phoneTypes.fax]: '팩스',
  [phoneTypes.other]: '기타',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
